import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBetalingsregelingAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00A75D"
      d="M28.84 26.32c-.59.59-1.54.59-2.12 0 .59.59.59 1.54 0 2.12-.59.59-1.54.59-2.12 0 .59.59.59 1.54 0 2.12-.59.59-1.54.59-2.12 0 .59.59.59 1.54 0 2.12-.59.59-1.54.59-2.12 0l-.68-.68-8.86-8.86-1-3.02c-.26-.79-.71-1.52-1.3-2.11l-1.24-1.24 5.66-5.66 1.23 1.23c.59.59 1.31 1.03 2.09 1.29l3.04 1.01 8.84 8.84.35.35.35.35c.59.59.59 1.54 0 2.12zm-2.47-15.91 7.07 7.07 3.54-3.54-.71-.71-6.36-6.36z"
    />
    <path
      fill="#A8D3AF"
      d="M19.65 29.15c.59.59.59 1.54 0 2.12l-.71.71c-.59.59-1.54.59-2.12 0a1.49 1.49 0 0 1 0-2.12c-.59.59-1.54.59-2.12 0a1.49 1.49 0 0 1 0-2.12l-.18.18c-.49.49-1.36.41-1.94-.18-.59-.59-.66-1.46-.18-1.94l.18-.18c-.59.59-1.54.59-2.12 0a1.49 1.49 0 0 1 0-2.12l.71-.71a1.49 1.49 0 0 1 2.12 0c.59.59.59 1.54 0 2.12l.88-.88c.49-.49 1.36-.41 1.94.18s.66 1.46.18 1.94l-.53.53a1.49 1.49 0 0 1 2.12 0c.59.59.59 1.54 0 2.12l-.35.35a1.49 1.49 0 0 1 2.12 0m7.42-18.03-.56.56c-.56.56-1.26.94-2.04 1.09l-2.9-.15c-1-.05-1.98.32-2.69 1.03l-3.48 3.48-.35.35-.35.35a1.49 1.49 0 0 0 0 2.12c.59.58 1.54.59 2.12 0l.35-.35 1.7-1.7c.26-.26.65-.35 1-.24l3.34 1.11q.33.105.57.36l4.7 4.7 1.78-1.78c.23-.23.38-.51.44-.82l.37-1.87c.15-.77.53-1.48 1.09-2.04l.56-.56-5.66-5.66z"
    />
    <path
      fill="#6FBC85"
      d="m10.1 6.88-.71.7-6.36 6.37 3.54 3.53 7.07-7.07z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBetalingsregelingAanvragen);

export default ForwardRef;
